export enum SortDirEnum {
  ASC = 'asc',
  DESC = 'desc',
}
